//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
To use Crosshair Icon
*/
import {IconCrosshair} from '../Icons';
//#endregion

//Used in Planner>>LocationInput 
//Gets current location on click 
const GeolocationButton = ({handleClick}) => {
    return(
        <button
            type="button"
            onClick={ () => getLocation(handleClick) }>
            <IconCrosshair />
        </button>
    );
};

const getLocation = callback => {
    // onClick let input know that value is loading
    callback({
        loading: true,
        error: false,
        coords: {}
    });
    /**
     * navigator.geolocation object is a global object that provides access to the user's location.
     * The getCurrentPosition() method takes two callbacks as arguments: a success callback and an error callback. 
     * In the success callback, the code gets the latitude and longitude of the user's location from the res object. 
     * The res object is an object that contains the user's location information
     */
    window.navigator.geolocation.getCurrentPosition(
        (res) => {
            
            callback({
                //reset loading and error property
                loading: false,
                error: false,
                coords: {
                    //Take coordinates from result
                    lat: res.coords.latitude,
                    lng: res.coords.longitude
                }
            });
        },
        /**
         * Called if the user's location cannot be retrieved. 
         */
        () => {
            callback({
                error: {
                    msg: 'Geolocation not available in your browser. Please try typing out your location.',
                    severity: 'error'
                },
                loading: false,
                coords: {}
            });
        },
        //getCurrentPosition() method will timeout after 8000 milliseconds if the user's location cannot be retrieved.
        { timeout: 8000 }
    );
};

export default GeolocationButton;